import ProductDetailTemplate from './product';
import ModalTemplate from './modal';
import CartTemplate from './cart';
import { CategoryTemplateCategory, CategoryTemplateHomepage } from './category';
import GlobalSettingsTemplate from './global-settings';
import ProductCardTemplate from './product/product-card';
import SearchTemplate from './search';
import AddressTemplate from './wholesaler/address';
import DomainTemplate from './wholesaler/domain';
export const components = {
    'react-product-detail': {
        component: ProductDetailTemplate,
        templateData: ['data-product-id'],
    },
    'react-cart': {
        component: CartTemplate,
        templateData: [],
    },
    'react-modal': {
        component: ModalTemplate,
        templateData: [],
    },
    'react-category': {
        component: CategoryTemplateCategory,
        templateData: ['data-category-id'],
    },
    'react-category-homepage': {
        component: CategoryTemplateHomepage,
        templateData: ['data-category-id'],
    },
    'react-product-card': {
        component: ProductCardTemplate,
        templateData: ['data-product'],
        each: true,
    },
    'react-global-settings': {
        component: GlobalSettingsTemplate,
        templateData: ['data-global-api'],
    },
    'react-search': {
        component: SearchTemplate,
        templateData: [],
    },
    'react-wholesaler-address': {
        component: AddressTemplate,
        templateData: ['countries'],
    },
    'react-wholesaler-domain': {
        component: DomainTemplate,
        templateData: ['input-placeholder'],
    },
};
